import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useMemo, useRef, useEffect } from 'react';
import { Button } from '../../../../components/atoms/Button/Button';
import { FilterTag } from '../../../../components/atoms/FilterTag/FilterTag';
import FilterAccordion from '../../../../components/molecules/FilterAccordion/FilterAccordion';
import { FaqCard } from '../../../../components/organisms/FaqCard/FaqCard';
import { FilterIcon } from '../../../../assets/icons/FilterIcon';
import * as Styled from './FAQList.style';
import { Search } from '../../../../components/molecules/Search/Search';
export const FAQList = ({ faqCards = [], filterSections: initialFilterSections = [], inverse = false, className }) => {
    const [isFilterOpen, setIsFilterOpen] = useState(false);
    const [filterSections, setFilterSections] = useState(initialFilterSections);
    const filterRef = useRef(null);
    // Close filter dropdown when clicking outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (filterRef.current && !filterRef.current.contains(event.target)) {
                setIsFilterOpen(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);
    // Filter FAQ cards based on selected filters
    const filteredCards = useMemo(() => {
        return faqCards.filter((card) => {
            const selectedValues = filterSections.flatMap(section => section.options.filter(opt => opt.checked).map(opt => opt.value));
            const matchesFilters = selectedValues.length === 0 || selectedValues.includes(card.type);
            return matchesFilters;
        });
    }, [faqCards, filterSections]);
    // Handle Filter Accordion Change
    const handleFilterChange = (_sectionId, value, checked) => {
        setFilterSections(prevSections => {
            return prevSections.map(section => {
                // If sectionId is provided, only update that section
                // Note: FilterAccordion implementation might not pass sectionId if it's not set on the section
                // We can try to find the option by value if sectionId is missing, assuming values are unique or we check all sections
                // If we know the section, great. If not, we iterate all.
                const updatedOptions = section.options.map(option => {
                    if (option.value === value) {
                        return Object.assign(Object.assign({}, option), { checked });
                    }
                    return option;
                });
                return Object.assign(Object.assign({}, section), { options: updatedOptions });
            });
        });
    };
    // Handle Tag Removal
    const handleTagRemove = (value) => {
        // Uncheck the option with this value
        handleFilterChange(undefined, value, false);
    };
    // Clear all filters
    const handleClearFilters = () => {
        setFilterSections(prevSections => prevSections.map(section => (Object.assign(Object.assign({}, section), { options: section.options.map(opt => (Object.assign(Object.assign({}, opt), { checked: false }))) }))));
    };
    // Get selected filters for tags
    const selectedFilters = useMemo(() => {
        return filterSections.flatMap(section => section.options.filter(opt => opt.checked).map(opt => ({
            label: opt.label,
            value: opt.value
        })));
    }, [filterSections]);
    const toggleFilterMenu = () => {
        setIsFilterOpen(!isFilterOpen);
    };
    return (_jsxs(Styled.Container, { "$inverse": inverse, className: className, children: [_jsx(Styled.StyledRichText, { inverse: inverse, children: _jsx("h1", { children: "Central de Ajuda" }) }), _jsxs(Styled.ContentWrapper, { children: [_jsx(Styled.SearchContainer, { children: _jsx(Search, { placeholder: "Buscar t\u00F3pico", inverse: inverse, ariaLabel: "Campo de busca de FAQ" }) }), _jsxs(Styled.FilterBlock, { children: [_jsxs(Styled.ActiveFiltersContainer, { children: [selectedFilters.map((filter) => (_jsx(FilterTag, { label: filter.label, onRemove: () => handleTagRemove(filter.value), inverse: inverse }, filter.value))), selectedFilters.length > 0 && (_jsx(Styled.ClearFiltersButton, { onClick: handleClearFilters, "$inverse": inverse, children: "Limpar filtros" }))] }), _jsxs(Styled.FilterButtonContainer, { ref: filterRef, children: [_jsx(Button, { label: "Filtrar", variant: "secondary", rightSvgIcon: _jsx(FilterIcon, { iconColor: "currentColor" }), onClick: toggleFilterMenu, inverse: inverse }), _jsx(Styled.FilterDropdown, { "$isOpen": isFilterOpen, "$inverse": inverse, children: _jsx(FilterAccordion, { sections: filterSections, onChange: handleFilterChange, defaultOpenAll: true }) })] })] }), _jsx(Styled.CardsList, { children: filteredCards.map((card, index) => (_jsx(FaqCard, Object.assign({}, card, { inverse: inverse }), index))) })] })] }));
};
export default FAQList;
//# sourceMappingURL=FAQList.js.map